import React, {useEffect, useState} from "react";
import InventoryModal from "./InventoryModal";
import {
    addInventoryForWorkshop,
    deleteInventoryForWorkshop,
    getInventoryForWorkshop,
    updateInventoryForWorkshop,
} from "../../Api/Api";
import {useWorkshop} from "../Common/WorkshopContext";
import ConfirmationModal from "./DeleteInventoryModal";
import {FaEdit, FaPlus, FaSearch} from "react-icons/fa";
import InventoryUsageChart from "./InventoryUsageChart";
import {useNotification} from "../Notification/NotificationContext";
import Pagination from "../Pagination/Pagination";

const InventoryList = () => {
    const [inventory, setInventory] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [showConfirmDelete, setShowConfirmDDelete] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [currentItem, setCurrentItem] = useState(null);
        const [searchTerm, setSearchTerm] = useState("");
    const { workshopId } = useWorkshop();
    const { showNotification } = useNotification();

    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const pageSize = 10;

    useEffect(() => {
        fetchInventory();
    }, [currentPage, searchTerm]);

    const fetchInventory = async () => {
        getInventoryForWorkshop(workshopId, pageSize, currentPage, searchTerm)
            .then((response) => {
                setInventory(response.data.content);
                setTotalPages(response.data.totalPages);
                setTotalCount(response.data.totalElements);
            })
            .catch((err) =>  showNotification(err.message, "error"));
    };

    const handleAdd = () => {
        setCurrentItem(null);
        setModalShow(true);
    };

    const handleEdit = (item) => {
        setCurrentItem(item);
        setModalShow(true);
    };

    const handleSave = async (item) => {
        if (currentItem) {
            // Update existing item
            updateInventoryForWorkshop(currentItem.id, workshopId, item)
                .then((response) => {
                    fetchInventory(); // Refresh inventory list
                    setCurrentItem(null);

                    showNotification("Updated Inventory successfully!", "success")
                })
                .catch((err) =>  showNotification(err.message, "error"));
        } else {
            // Add new item
            addInventoryForWorkshop(workshopId, item)
                .then((response) => {
                    showNotification("Added Inventory successfully!", "success")
                    fetchInventory(); // Refresh inventory list
                    setCurrentItem(null);
                })
                .catch((error) =>  showNotification(error.message, "error"));
        }
        setModalShow(false);
    };

    const handleDeleteClick = (id) => {
        setSelectedItemId(id);
        setShowConfirmDDelete(true); // Show the confirmation modal
    };

    const handleConfirmDelete = async () => {
        try {
            await deleteInventoryForWorkshop(workshopId, selectedItemId); // Call the API
            setShowConfirmDDelete(false); // Close the modal
            setSelectedItemId(null);
            fetchInventory(); // Refresh inventory list
        } catch (error) {
            showNotification(error.message, "error")
        }
    };

    const handleCancelDelete = () => {
        setShowConfirmDDelete(false); // Close the modal
        setSelectedItemId(null);
    };

    return (
        <div className="mt-6">
            <div className="max-w-screen-xl mx-auto">
                <div className="bg-white shadow-lg rounded-lg overflow-hidden">
                    {/* Header - Matches JobCardList */}
                    <div className="bg-teal-400 text-white p-3 rounded-t-lg flex justify-between items-center">
                        <h2 className="text-xl font-semibold">Inventory List</h2>
                        <div className="flex gap-2 items-center w-full sm:w-auto">
                            <div className="relative w-full sm:w-64">
                                <input
                                    type="text"
                                    placeholder="Search by name"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="w-full pl-10 pr-4 py-2 rounded-md focus:outline-none text-gray-700"
                                />
                                <FaSearch className="absolute left-3 top-2.5 text-gray-400" />
                            </div>
                            <button
                                onClick={handleAdd}
                                className="bg-white text-teal-500 px-4 py-2 rounded-md flex items-center hover:bg-gray-200 transition"
                            >
                                Add Item
                            </button>
                        </div>

                    </div>

                    {/* Table Section - Matches JobCardList */}
                    <div className="p-6">
                        {inventory && inventory.length > 0 ? (
                            <div className="overflow-x-auto shadow-md rounded-lg">
                                <table className="min-w-full bg-white">
                                    <thead className="bg-gray-50 text-gray-800">
                                    <tr>
                                        <th className="p-2 text-left">Id</th>
                                        <th className="p-2 text-left">Name</th>
                                        <th className="p-2 text-left">Type</th>
                                        <th className="p-2 text-left">Quantity</th>
                                        <th className="p-2 text-left">Warranty Period</th>
                                        <th className="p-2 text-left">Price</th>
                                        <th className="p-2 text-left">Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {inventory.map((item) => (
                                        <tr key={item.id} className="border-b hover:bg-gray-100">
                                            <td className="p-2">{item.id}</td>
                                            <td className="p-2">{item.name}</td>
                                            <td className="p-2">{item.type}</td>
                                            <td className="p-2">{item.quantity}</td>
                                            <td className="p-2">{item.warrantyPeriod}</td>
                                            <td className="p-2">{item.price}</td>
                                            <td className="p-2 flex space-x-2">
                                                <button
                                                    onClick={() => handleEdit(item)}
                                                    className="flex items-center bg-yellow-500 text-white px-3 py-1 rounded-md shadow hover:bg-yellow-600 transition"
                                                >
                                                    <FaEdit className="mr-1" /> Edit
                                                </button>
                                                <button
                                                    onClick={() => handleDeleteClick(item.id)}
                                                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 transition"
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center text-gray-600 py-10">
                                No inventory items found.
                            </div>
                        )}
                        <div className="flex justify-start mt-4">
                            <Pagination
                                totalPages={totalPages}
                                onPageChange={setCurrentPage}
                                currentPage={currentPage}
                                totalCount={totalCount}
                            />
                        </div>
                    </div>

                </div>

                {/* Inventory Modal */}
                <InventoryModal
                    show={modalShow}
                    handleClose={() => setModalShow(false)}
                    handleSave={handleSave}
                    item={currentItem}
                />

                {/* Confirmation Modal */}
                <ConfirmationModal
                    show={showConfirmDelete}
                    message="Are you sure you want to delete this inventory item? This action cannot be undone."
                    onConfirm={handleConfirmDelete}
                    onCancel={handleCancelDelete}
                />
                <br/>
                <br/>
                <InventoryUsageChart workshopId={workshopId} />
            </div>
        </div>
    );
};

export default InventoryList;